import {
  boolean,
  enum_,
  type InferOutput,
  number,
  object,
  optional,
  string
} from 'valibot'

import {
  createSorterSchema,
  PARTNERS_SORT_KEYS
} from '@/features/shared/models'
import { PARTNER_TYPE } from '@/libs/api/types'

export const PartnersListSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(PARTNERS_SORT_KEYS), // ソートキーと順序
  companyName: optional(string()), // 会社名
  name: optional(string()), // パートナー名
  code: optional(string()), // パートナーコード
  dcId: optional(number()), // DC ID
  type: optional(enum_(PARTNER_TYPE)),
  enable: optional(boolean()) // 有効状態
})

export type PartnersListSearch = InferOutput<typeof PartnersListSearchSchema>
